<template>
  <div style="height: 100%; display: flex; flex-direction: column;">
    <div class="status" v-if="offline">
      <span>Offline</span>
    </div>
    <div class="container" :style="settings.style" v-html="settings.content">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Screen',
  data() {
    return {
      offline: false,
      offline_count: 0,
      offline_interval:null,
      refresh_content_interval:null,
      interval:null,
      settings: {
        style: '',
        content: '<style>@keyframes blink{0%{opacity:.2}20%{opacity:1}100%{opacity:.2}}.saving span{animation-name:blink;animation-duration:1.4s;animation-iteration-count:infinite;animation-fill-mode:both}.saving span:nth-child(2){animation-delay:.2s}.saving span:nth-child(3){animation-delay:.4s}</style><div class="saving" style="font-size:50px; text-align:center; color:white; height:100%; line-height: calc(100vh - 60px/2);"><span>Henter data<span>.</span><span>.</span><span>.</span></div>',
      }
    }
  },
  sockets: {
    refreshContent() {
      console.log("tester");
      this.getData();
    }
  },
  methods: {
    checkOffline: function(){
      console.log();
      if(this.$socket.disconnected){
        if(this.offline_count>60){
          this.offline=true;
        }
        this.offline_count++;
        console.log("offline "+this.offline_count);
      }else{
        this.offline_count = 0;
        this.offline = false;
        console.log("resat offline "+this.offline_count);
      }

    },
      timerView: function(){
        var now = new Date();
        var list = document.getElementsByClassName("dateReplace");
            for(var i = 0; i < list.length; i++)
            {
                if(list[i].classList.contains("dayname")){
                    list[i].innerText = ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"][now.getDay()];
                }else if (list[i].classList.contains("monthname")){
                    list[i].innerText = ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"][now.getMonth()];
                }else if (list[i].classList.contains("day")){
                    list[i].innerText = now.getDate();
                }else if (list[i].classList.contains("year")){
                    list[i].innerText = now.getFullYear();
                }else if (list[i].classList.contains("month")){
                    list[i].innerText = now.getMonth()+1;
                }else if (list[i].classList.contains("hours")){
                    list[i].innerText = ("0" + now.getHours()).slice(-2);
                }else if (list[i].classList.contains("minuts")){
                    list[i].innerText = ("0" + now.getMinutes()).slice(-2);
                }else if (list[i].classList.contains("sec")){
                    list[i].innerText = ("0" + now.getSeconds()).slice(-2);
                }
            }
      },
    getData: function(){
      var vue = this;
      this.$socket.client.emit('getContent','test', (error, response) => {
        if(error=='200'){
          vue.settings.style = response.settings;
          vue.settings.content = response.content;
        }else{
          vue.settings.content = response;
        }
      })
      console.log("getting content");
    }
  },
  mounted() {
    this.getData();
    this.checkOffline();
    this.refresh_content_interval = setInterval(() => {
      this.$router.go(0);
    },21600000);
    this.offline_interval = setInterval(() => {
      this.checkOffline();
    },1000);
    this.interval = setInterval(() => {
      this.timerView();
    },1000);
  },
  beforeDestroy() {
    clearInterval(this.refresh_content_interval);
    clearInterval(this.offline_interval);
    clearInterval(this.interval);
  }
}
</script>

<style scoped>
*{
  overflow: hidden;
}
.status{
  padding: 10px 5px;
  background-color: rgba(236, 58, 58, 0.5);
  color: white;
  text-align: center;
  font-family: sans-serif;
  font-size: 2rem;
  flex-shrink: 0;
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.status svg{
  height: 2.3rem;
  width: 2.3rem;
  margin-left: 10px;
}
.container > * {
  height: 100%;
}
.container {
  height: 100%;
}
</style>
